<div class="projects-container py-4 py-lg-3 my-lg-4 my-xl-0">
    <div class="container">
        <div class="row mb-3">
            <div class="col-12 col-sm-6">
                <div class="d-flex align-items-center justify-content-center justify-content-sm-start h-100">
                    <p class="fs-16 fw-sbold mb-0">Oportunidades disponibles <br><span class="span-line"></span></p>
                </div>
            </div>
            <!--
            <div class="col-12 col-sm-6 my-3 my-sm-0">
                <div class="d-flex align-items-center justify-content-center justify-content-sm-end">
                    <a class="btn fs-15 cl-white bg-primary" [routerLink]="devsPath">Ver todos los proyectos</a>
                </div>
            </div>
            -->
        </div>
        <div class="list-container" [ngClass]="userWithBothStatus ? 'banner-true' : 'banner-false'">
            <div>
                <mnf-new-card-project-list *ngFor="let dev of devs" [dev]="dev"></mnf-new-card-project-list>
            </div>
        </div>
    </div>
</div>